<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} entrada
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="preSave()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Motivo entrada<span class="required"></span></label>
                  <select class="form-control" id="conceptSelected" formControlName="warehouseconcept_id" required>
                    <option value="null">Seleccionar opción</option>
                    <option *ngFor="let item of concepts" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['warehouseconcept_id'].errors">
                    <small class="text-danger" *ngIf="f['warehouseconcept_id'].errors['required']">El campo es
                      requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Destino almacén<span class="required"></span></label>
                  <select class="form-control" id="warehousesSelected" formControlName="warehouse_id" required>
                    <option *ngFor="let item of warehouses" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['warehouse_id'].errors">
                    <small class="text-danger" *ngIf="f['warehouse_id'].errors['required']">El campo es
                      requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Fecha <span class="required"></span></label>
                  <input type="text" id="date_movement" formControlName="date_movement" class="form-control" required>
                  <div *ngIf="submitted && f['date_movement'].errors">
                    <small class="text-danger" *ngIf="f['date_movement'].errors['required']">El campo es
                      requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Seleccione producto <span class="bold f-s-10">(Tipo bienes)</span></label>
                  <component-search-product [typeProduct]="1" [controlStock]="true"
                    (selectedProductEvent)="selectedProductSearch($event)"> </component-search-product>
                </div>
                <div class="form-group col-lg-6">
                  <label>Observaciones</label>
                  <input type="text" id="entry_reason" formControlName="reason" class="form-control">
                </div>

                <div class="col-lg-12 m-t-10">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th>Nombre producto</th>
                          <th class="w-15 text-center">U. Medida</th>
                          <th class="w-15 text-right">Cantidad</th>
                          <th class="w-15 text-right">
                            Precio Compra <span data-toggle="tooltip" data-placement="right"
                              data-original-title="Precio unitario de compra" title=""><i
                                class="fas fa-info-circle m-l-5"></i></span>
                          </th>
                          <th class="text-center">Fecha vcto.
                            <span data-toggle="tooltip" data-placement="right"
                              data-original-title="Fecha de vencimiento del lote a ingresar" title=""><i
                                class="fas fa-info-circle m-l-5"></i></span>
                          </th>
                          <th class="w-10 text-right">SubTotal</th>
                          <th class="w-5 text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="products.length == 0">
                          <td colspan="2"><span>No se encontraron registros</span></td>
                        </ng-container>
                        <ng-container *ngIf="products.length > 0">
                          <tr *ngFor="let item of products; let index_ = index">
                            <td>
                              {{item.description}}
                              <p class="m-b-0 bold f-s-10">{{item.code}}</p>
                              <ng-container *ngIf="!item.is_control_stock">
                                <span class="badge badge-warning">El control de stock se activará
                                  automáticamente</span>
                              </ng-container>
                            </td>
                            <td class="w-15">
                              <select class="form-control form-control-sm" id="unitSelected{{index_}}"
                              (change)="changeUnitSelected($event.target,index_, item)">
                                <option *ngFor="let unit of item.unitsmeasure" [value]="unit.id">
                                  {{unit.description}}({{unit.equivalence}})</option>
                              </select>
                            </td>
                            <td class="w-15">
                              <input type="text" id="quantity{{index_}}" value="{{item.quantity}}"
                                (keyup)="changeQuantity($event.target, index_)" numeric decimals="2"
                                onclick="click_input(this)" class="form-control form-control-sm text-right bold"
                                required>
                            </td>
                            <td class="w-15">
                              <input type="text" id="price{{index_}}" value="{{item.price}}"
                                (keyup)="changePrice($event.target, index_)" numeric decimals="2"
                                onclick="click_input(this)" class="form-control form-control-sm text-right"
                                required="true">
                            </td>
                            <td class="text-center">
                              <div class="input-group">
                                <div class="input-group-prepend input-group-sm">
                                  <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                      id="check_date_expiration{{index_}}" (change)="changeDateExpiration(index_)">
                                    <label class="custom-control-label p-t-3" for="check_date_expiration{{index_}}">
                                      <span class="f-s-10 m-r-10" *ngIf="!item.check_date_expiration"> Activar control
                                      </span>
                                    </label>
                                  </div>
                                  <input type="text" class="form-control form-control-sm text-center" id="expiration_date{{index_}}"
                                    [disabled]="!item.check_date_expiration">
                                </div>
                              </div>
                            </td>
                            <td class="w-10 text-right">
                              <span class="bold">{{toolsService.momeySol()}} {{item.subtotal}}</span>
                            </td>
                            <td class="w-5 text-center">
                              <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                (click)="removeProduct(index_)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
